import { numberWithCommas } from "common/number";
import { HeaderButton } from "components/layout/button";
import paths from "routes/paths";
import { useAppSelector } from "store";
import { authNewSelectors } from "store/reducers/auth-new";

import css from "./index.module.scss";

export const Credits = () => {
  const countLeft = useAppSelector(authNewSelectors.creditLeftGet);
  const isLoggedIn = useAppSelector(authNewSelectors.loggedInGet);
  const trialActive = useAppSelector(authNewSelectors.trialActiveGet);

  return (
    <div className={css.wrapper}>
      {isLoggedIn && (
        <span className={css.credits}>
          <span>{trialActive ? "Trial credits" : "Credits"}:</span>
          <strong>{numberWithCommas(countLeft)}</strong>
        </span>
      )}
      {!trialActive && (
        <HeaderButton className={css.button} small to={paths.purchase()}>
          Add {countLeft === 0 && "Credits"}
        </HeaderButton>
      )}
    </div>
  );
};
